/**
 * Created with Mei Zhiwei on 2018-08-06 01:57:27.
 * Description: 入口
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: fanzhijie
 * @Last Modified time: 2021-04-29 19:13:21
 */
<template>
  <div id="app">
    <div class="layout">
      <Layout>
        <Header :style="{padding: '0', background: '#fff', 'box-shadow': '0 2px 2px rgba(0,0,0,.08)', 'z-index': '901'}" :class="isHome ? 'home' : 'page'">
          <Menu mode="horizontal" class="head-nav" :theme="isHome ? 'dark' : 'light'" :active-name="activeName" @on-select="routeTo" :style="{'width': '100%', 'max-width': '1300px', 'margin': '0 auto', 'padding': '0 50px'}">
            <div class="layout-logo" @click="goToHome">美团餐饮直连平台</div>
            <div class="layout-nav">
              <!-- <MenuItem name="home">
                <Icon type="ios-navigate"></Icon>
                首页
              </MenuItem> -->
              <Submenu name="docs">
                <template slot="title">
                  <Icon type="ios-paper" />
                  解决方案
                </template>
                <MenuItem v-for="(item, index) in opBizList.bizList" :key="index" :name="item.uniqueId" >
                  <Icon :type="item.icon"></Icon>
                  {{item.name}}
                </MenuItem>
                <!-- <MenuItem v-for="opbiz in opBizList" >
                  <Icon type="ios-analytics"></Icon>
                  {{opbiz.title}}
                </MenuItem> -->
                <!-- <MenuItem name="couponDocOverView">
                  美团码验证解决方案
                </MenuItem>
                <MenuItem name="orderDocOverView">
                  <Icon type="ios-paper"></Icon>
                  点餐解决方案
                </MenuItem>
                <MenuItem name="qrpayDocOverview">
                  <Icon type="md-expand"></Icon>
                  C扫B支核一体
                </MenuItem>
                <MenuItem name="shopDocOverView">
                  <Icon type="md-desktop"></Icon>
                  门店直连
                </MenuItem>
                <MenuItem name="productDocOverView">
                  <Icon type="md-beer"></Icon>
                  上单直连
                </MenuItem>
                <MenuItem name="helpDocOverView">
                  <Icon type="md-help-circle" />
                  帮助
                </MenuItem> -->
              </Submenu>
              <MenuItem name="accountDetail">
                <Icon type="ios-construct" />
                开发者中心
              </MenuItem>
              <Submenu v-if="user.uid" name="user">
                <template slot="title">
                  {{ user.login }}
                </template>
                <!--<MenuItem name="accountName">-->
                  <!--账号设置-->
                <!--</MenuItem>-->
                <MenuItem name="logout">
                  退出
                </MenuItem>
              </Submenu>
              <MenuItem name="login" v-else>请登录</MenuItem>
            </div>
          </Menu>
        </Header>
        <Layout :style="{background: '#eee'}">
          <router-view></router-view>
        </Layout>
        <Footer class="layout-footer-center">2021 &copy; 美团</Footer>
      </Layout>
    </div>
    <BackTop :bottom="100" :right="50">
      <Icon :style="{padding: '8px', color: '#6b6b6b', border: '1px solid #eee', boxShadow: '0 2px 4px 0 rgba(111, 130, 166, 0.1)', borderRadius: '50%'}" type="md-plane" />
    </BackTop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { host } from '@/config';
import { getBizUni } from '@/lib/utils.js';

export default {
  name: 'App',
  computed: {
    activeName() {
      let path = this.$router.path;
      if (path) {
        return getBizUni(path);
      }
    },
    ...mapGetters({
      user: 'base/loginUser',
      opBizList: 'base/opBizList'
    }),
    isHome() {
      return this.activeName === 'home';
    }
  },
  created() {
    this.$store.dispatch('base/loadUser');
    this.$store.dispatch('base/loadOpBizList');
  },
  methods: {
    routeTo(e) {
      if (e !== 'logout') {
        if (e === 'developerOverview' && this.user.vendorId < 1) {
          this.$Message.info('请先注册账户并完成入驻申请');
          this.$router.push({ name: 'register' });
        } else if (e === 'login') {
          window.location = host.LOGIN;
        } else if (e === 'accountDetail' && this.user.vendorId < 1) {
          if (this.user.uid || this.user.pUid) {
            // 已登录 未入驻
            this.$Message.info('当前未入驻，请联系贵品牌的BD运营进行入驻沟通');
          } else {
            // click 开发者中心，但是未登陆
            window.location = host.LOGIN;
          }
        } else if (e.indexOf('BizUni_') === 0) {
          // bizUni 开头，点击解决方案业务
          this.$router.push(
            {
              name: 'docOverView',
              params: {
                uni: e
              }
            });
        } else {
          this.$router.push({ name: e });
        }
      } else {
        window.location = host.PASSPORT_LOGOUT;
      }
    },
    goToHome: function() {
      this.$router.push({ name: 'home' });
    }
  }
};
</script>

<style lang="less">
.layout {
  position: relative;
  overflow: hidden;
}
.layout-logo {
  float: left;
  position: relative;
  font-size: 16px;
  cursor: pointer;
}
.layout-nav {
  float: right;
}
.layout-footer-center {
  background: #eee;
  text-align: center;
}
.layout-center {
  width: 100%;
  padding: 0 auto;
}
.head-nav:after {
  content: none !important;
}
.home {
  background: #111 !important;
  z-index: 1000;
  .layout-logo {
    color: #fff;
  }
  .head-nav {
    background: #111;
  }
  .head-nav li {
    color: #fff !important;
    &:hover {
      background: #333 !important;
    }
  }
  .ivu-select-dropdown {
    background: #111 !important;
  }
}
.page:before {
  position: absolute;
  content: '';
  width: 100%;
  height: 2px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fc673d;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue